import { NotificationsMobilePage } from '@/pages/mobile/shared/NotificationsMobilePage';

export function LeaderNotificationsPage() {
  return <NotificationsMobilePage variant="leader" />;
}
